import React, { useContext, useEffect } from 'react';
import { LanguageContext } from '../contexts/LanguageContext';
import AOS from 'aos';
import 'aos/dist/aos.css';

// Partner data with company name and logo path
const partners = [
  { 
    name: 'Microsoft', 
    logo: '/images/partners/microsoft.png',
    height: 60
  },
  { 
    name: 'Red Hat', 
    logo: '/images/partners/redhat.png',
    height: 55
  },
  { 
    name: 'Dell', 
    logo: '/images/partners/dell.png',
    height: 60
  },
  { 
    name: 'Citrix', 
    logo: '/images/partners/citrix.png',
    height: 50
  },
  { 
    name: 'Bosch', 
    logo: '/images/partners/bosch.png',
    height: 48
  },
  { 
    name: 'Canonical', 
    logo: '/images/partners/canonical.png',
    height: 55
  },
  { 
    name: 'Portworx', 
    logo: '/images/partners/portworx.png',
    height: 50
  },
  { 
    name: 'CNCF', 
    logo: '/images/partners/cncf.png',
    height: 58
  },
  { 
    name: 'Kubernetes', 
    logo: '/images/partners/kubernetes.png',
    height: 60
  },
];

const PartnerLogos = () => {
  const { translations } = useContext(LanguageContext);
  
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      mirror: false,
      easing: 'ease-out-cubic'
    });
    
    return () => {
      AOS.refresh();
    };
  }, []);
  
  // Function to render a partner logo
  const renderLogo = (partner, key) => (
    <div 
      key={key} 
      className="flex-shrink-0 h-28 flex items-center justify-center px-8 mx-8"
    >
      <div className="bg-white p-6 rounded-lg flex items-center justify-center opacity-90 hover:opacity-100 transition-all duration-300 shadow-md hover:shadow-lg transform hover:scale-105 w-60 h-28">
        <div className="flex items-center justify-center h-full">
          <img 
            src={partner.logo} 
            alt={`${partner.name} logo`} 
            style={{ height: `${partner.height}px` }}
            className="object-contain max-w-[180px]"
            onError={(e) => {
              // Fallback if image fails to load
              e.target.onerror = null;
              e.target.style.display = 'none';
              const nameElement = document.createElement('span');
              nameElement.className = 'font-bold text-blue-700 dark:text-blue-300 text-xl';
              nameElement.innerText = partner.name;
              e.target.parentNode.appendChild(nameElement);
            }}
          />
        </div>
      </div>
    </div>
  );
  
  return (
    <div className="py-8 bg-blue-50 dark:bg-gray-900 overflow-hidden border-t border-b border-blue-100 dark:border-gray-700">
      <div className="container mx-auto px-4">
        <div className="text-center mb-8" data-aos="fade-up">
          <h2 className="text-3xl md:text-4xl font-bold text-blue-900 dark:text-white mb-4">
            {translations['home.partners.title'] || 'Industry Partners'}
          </h2>
        </div>
        
        <div className="relative max-w-full overflow-hidden">
          {/* Add extremely subtle gradient borders at the far edges */}
          <div className="absolute top-0 bottom-0 left-0 w-2 bg-gradient-to-r from-blue-50 to-transparent dark:from-gray-900 z-10" style={{ left: '-1px' }}></div>
          <div className="absolute top-0 bottom-0 right-0 w-2 bg-gradient-to-l from-blue-50 to-transparent dark:from-gray-900 z-10" style={{ right: '-1px' }}></div>
          
          {/* Container for the sliding animation */}
          <div className="flex items-center overflow-hidden whitespace-nowrap py-4 mx-auto">
            {/* First set of logos that will be animated */}
            <div className="inline-flex animate-scroll-x space-x-16">
              {partners.map((partner, index) => renderLogo(partner, `partner-1-${index}`))}
            </div>
            
            {/* Duplicate set of logos for seamless scrolling */}
            <div className="inline-flex animate-scroll-x space-x-16">
              {partners.map((partner, index) => renderLogo(partner, `partner-2-${index}`))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PartnerLogos;
